/* A */
export const AGENT_LOOKUP = 'AGENT_LOOKUP';
export const AGENT_LOOKUP_FAIL = 'AGENT_LOOKUP_FAIL';
export const AGENT_LOOKUP_SUCCESS = 'AGENT_LOOKUP_SUCCESS';

export const SELECT_AGENT = 'SELECT_AGENT';
export const SELECT_AGENT_FAIL = 'SELECT_AGENT_FAIL';
export const SELECT_AGENT_SUCCESS = 'SELECT_AGENT_SUCCESS';

/* G */
export const GET_CURRENT_AGENT = 'GET_CURRENT_AGENT';
export const GET_CURRENT_AGENT_FAIL = 'GET_CURRENT_AGENT_FAIL';
export const GET_CURRENT_AGENT_SUCCESS = 'GET_CURRENT_AGENT_SUCCESS';

/* S */
export const SET_GROUP_TYPE = 'SET_GROUP_TYPE';
